import { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { clearTokens } from '../../services/api/apiClient';

export default function ApiErrorNotifier() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const onError = (e) => setError(e.detail);
    const onExpired = () => {
      clearTokens();
      navigate('/login', { replace: true, state: { reason: 'expired' } });
    };
    window.addEventListener('mcg:api-error', onError);
    window.addEventListener('mcg:auth-expired', onExpired);
    return () => {
      window.removeEventListener('mcg:api-error', onError);
      window.removeEventListener('mcg:auth-expired', onExpired);
    };
  }, [navigate]);

  return (
    <Snackbar open={Boolean(error)} autoHideDuration={9000} onClose={() => setError(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      {error ? (
        <Alert severity={error.status >= 500 ? 'error' : 'warning'} onClose={() => setError(null)} sx={{ maxWidth: 520 }}>
          <strong>{error.code}</strong> — {error.message}
          {/* Never show `guidance` here — the backend no longer sends it for this
              reason, but even if a stale/third-party response included it, it's
              internal developer instructions and must not reach the user. */}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
}
